export default __webpack_public_path__ + "static/media/239.0d356e95.jpg";